var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxPaymentCouponOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 14.3691C2.80078 14.9809 3.29589 15.4768 3.90662 15.4768H16.095C16.7056 15.4768 17.2008 14.9809 17.2008 14.3691V12.1161C16.2434 11.8561 15.5391 10.9796 15.5391 9.93836C15.5391 8.8971 16.2434 8.02059 17.2008 7.76067V5.50759C17.2008 4.89584 16.7056 4.3999 16.095 4.3999H3.90662C3.29589 4.3999 2.80078 4.89583 2.80078 5.50759V7.7558C3.76746 8.00949 4.48066 8.8905 4.48066 9.93836C4.48066 10.9862 3.76746 11.8672 2.80078 12.1209V14.3691Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25586 12.7077L12.7943 7.16919",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80971 8.27688C8.11558 8.27688 8.36355 8.02891 8.36355 7.72304C8.36355 7.41716 8.11558 7.16919 7.80971 7.16919C7.50383 7.16919 7.25586 7.41716 7.25586 7.72304C7.25586 8.02891 7.50383 8.27688 7.80971 8.27688Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2394 12.7075C12.5453 12.7075 12.7932 12.4596 12.7932 12.1537C12.7932 11.8478 12.5453 11.5999 12.2394 11.5999C11.9335 11.5999 11.6855 11.8478 11.6855 12.1537C11.6855 12.4596 11.9335 12.7075 12.2394 12.7075Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxPaymentCouponOutline);
export default __webpack_public_path__ + "static/media/icon_20px_payment-coupon_outline.c916a156f5708eb1cc623933e77c6b61.svg";
export { ForwardRef as ReactComponent };